import { useEffect, useState } from 'react';
import SiteHeader from '../components/SiteHeader';
import { useAuth } from '../auth/AuthContext';
import { authedJson } from '../api/client';
import type { Me } from '../../../shared/types';

/**
 * Protected page. Fetches `GET /me` through the authed client so the whole
 * authorizer → access-token → silent-refresh path is exercised end to end.
 */
export default function ProfilePage() {
  const { getToken, refresh } = useAuth();
  const [me, setMe] = useState<Me | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    authedJson<Me>('/me', { method: 'GET' }, getToken, refresh)
      .then(data => { if (!cancelled) setMe(data); })
      .catch(err => { if (!cancelled) setError(err instanceof Error ? err.message : 'Failed to load profile'); });
    return () => { cancelled = true; };
  }, [getToken, refresh]);

  return (
    <>
      <SiteHeader back={{ label: 'Home', to: '/' }} />
      <main className="page page--narrow">
        <h1>Profile</h1>
        {error && <p className="error">{error}</p>}
        {!me && !error && <p className="muted">Loading…</p>}
        {me && (
          <div className="form-card">
            <div><span className="muted">Display name</span><div>{me.displayName}</div></div>
            <div><span className="muted">Email</span><div>{me.email}</div></div>
            <div><span className="muted">User ID</span><div style={{ fontSize: 13 }}>{me.userId}</div></div>
            <div>
              <span className="muted">Member since</span>
              <div>{new Date(me.createdAt * 1000).toLocaleDateString()}</div>
            </div>
          </div>
        )}
      </main>
    </>
  );
}
